<template>
  <CouponList />
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import CouponList from "../components/CouponList.vue";
export default Vue.extend({
  name: "Coupon",
  components: {
    CouponList,
  },
})
</script>
